import { render, staticRenderFns } from "./statData.vue?vue&type=template&id=f247a012&scoped=true"
import script from "./statData.vue?vue&type=script&lang=js"
export * from "./statData.vue?vue&type=script&lang=js"
import style0 from "./statData.vue?vue&type=style&index=0&id=f247a012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f247a012",
  null
  
)

export default component.exports